import pick from 'lodash/fp/pick'

import {
  AutomationsPresentationV1,
  type AutomationsPresentationV1Edge,
  type AutomationsPresentationV1Node
} from 'Automations/automationEditor'
import { dedupeEdges } from '../dedupeEdges'

export const presentationToApiPresentation = (
  presentation: AutomationsPresentationV1
): AutomationsPresentationV1 => {
  return {
    ...presentation,
    nodes: presentation.nodes.map(node => {
      return pick(['id', 'type', 'position', 'data'])(
        node
      ) as AutomationsPresentationV1Node
    }),
    // Edges get the same treatment as nodes, for the same reason: the canvas
    // decorates each one with `type`/`zIndex`/`data` before rendering, and a
    // rewired edge carries that back into the atom, so two versions could
    // otherwise differ by styling alone. De-duplicating here keeps the saved
    // body and the unsaved-changes check agreeing on one copy per connection.
    edges: dedupeEdges(presentation.edges).map(
      edge =>
        pick(['id', 'source', 'sourceHandle', 'target', 'targetHandle'])(
          edge
        ) as AutomationsPresentationV1Edge
    )
  }
}
